import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { useAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { jsx as ___EmotionJSX } from "@emotion/core";
var withGraphQLProvider = WrappedComponent => {
  var Hoc = props => {
    var _ref = useAllhomesContext() || {},
      getApolloClient = _ref.getApolloClient;
    var client = getApolloClient();
    return client && ___EmotionJSX(ApolloProvider, {
      client: client
    }, ___EmotionJSX(WrappedComponent, props));
  };
  setHOCDisplayName(Hoc, WrappedComponent, 'graphqlProvider');
  return Hoc;
};
export default withGraphQLProvider;